import { usePhoneStore } from '../store/phone';

/** 模拟 CDR 行（挂断后动态落库最新一条，服务小结据此定位；顶部为最新） */
export const mockCdrRows: Record<string, any>[] = [
  {
    id: 9001,
    direction: 'outbound',
    caller: '1001',
    callee: '13900001111',
    original_callee: '13900001111',
    agent_id: 7,
    agent_name: '测试坐席',
    participants: [
      { name: '测试坐席', role: 'agent', action: 'answer' },
      { name: '陈刚', role: 'duty', action: 'three_way' },
      { name: '罗敏', role: 'leader', action: 'listen' },
      { name: '李工', role: 'expert', action: 'consult' },
    ],
    state: 'completed',
    duration: 42,
    billsec: 38,
    start_time: new Date(Date.now() - 3600_000).toISOString(),
    end_time: new Date(Date.now() - 3600_000).toISOString(),
    created_at: new Date(Date.now() - 3600_000).toISOString(),
  },
];

let mockCdrSeq = 9002;

/** 本通结束复位（对齐 cleanupSession 的 UI 语义：registered、保留 extension/customer；
 *  transferredOut 不清——消费方（小结触发/话后快照）读取后自行复位）
 *  正常挂断（in-call 且非盲转）时按本通信息补一条 CDR，供服务小结定位/展示 */
export function endCall() {
  const prev = usePhoneStore.getState();
  if (prev.status === 'in-call' && !prev.transferredOut && prev.remoteNumber) {
    const inbound = prev.direction === 'in';
    const dur = Math.max(1, Math.round(((prev.startedAt ? Date.now() - prev.startedAt : 3000) || 3000) / 1000));
    mockCdrRows.unshift({
      id: mockCdrSeq++,
      uuid: `mock-uuid-${mockCdrSeq - 1}`,
      direction: inbound ? 'inbound' : 'outbound',
      caller: inbound ? prev.remoteNumber : '1001',
      callee: inbound ? '1001' : prev.remoteNumber,
      agent_id: 7,
      state: 'completed',
      duration: dur,
      billsec: Math.max(1, dur - 1),
      record_url: `https://example.com/mock-record-${mockCdrSeq - 1}.mp3`,
      end_time: new Date().toISOString(),
      created_at: new Date().toISOString(),
    });
    if (mockCdrRows.length > 6) mockCdrRows.length = 6;
  }
  usePhoneStore.setState((p) => ({
    ...p,
    status: 'registered',
    remoteNumber: '',
    direction: '',
    muted: false,
    held: false,
    startedAt: undefined,
    consultPhase: '',
    consultDest: '',
  }));
}
